'use client';

export { default } from './FormControlLabel';
export { default as formControlLabelClasses } from './formControlLabelClasses';
export * from './formControlLabelClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/FormControlLabel/index.js
// module id = 523
// module chunks = 25